// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2fs-N","header":"MergedInvoice_header__1VcHf"};